module.exports = __webpack_public_path__ + "img/sports.a26c717b.svg";